"use client";

import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import {
  PORTFOLIO_INSIGHT_ALERT_SVG_NAME,
  PORTFOLIO_INSIGHT_NOTICE_SVG_NAME,
} from "./portfolioInsightIconContract";

export type PortfolioInsightErrorCircleVariant = "alert" | "notice";

const SVG_BY_VARIANT: Record<PortfolioInsightErrorCircleVariant, string> = {
  /** H5 card · `88972:41618` */
  alert: PORTFOLIO_INSIGHT_ALERT_SVG_NAME,
  /** PC notice · `88100:38276` */
  notice: PORTFOLIO_INSIGHT_NOTICE_SVG_NAME,
};

interface PortfolioInsightErrorCircleIconProps {
  /** `alert` = H5 red ring; `notice` = PC orange solid (Figma 38276) */
  variant?: PortfolioInsightErrorCircleVariant;
  className?: string;
  "data-testid"?: string;
}

export const PortfolioInsightErrorCircleIcon: React.FC<
  PortfolioInsightErrorCircleIconProps
> = ({
  variant = "alert",
  className,
  "data-testid": testId = "portfolio-insight-error-icon",
}) => {
  const iconName = SVG_BY_VARIANT[variant];
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center",
        className,
      )}
      data-testid={testId}
      data-icon-source="osp-svg"
      data-icon-name={iconName}
      data-icon-variant={variant}
      aria-hidden
    >
      <Icon name={iconName} size={20} />
    </span>
  );
};
